{
  "title": "Projects",
  "empty": "No projects yet",
  "emptyLead": "Connect a Hetzner Cloud project to manage it here.",
  "add": "Connect a project",
  "name": "Project name",
  "token": "API token",
  "tokenHelp": "In the Hetzner Console open the project, Security → API tokens, generate a Read & Write token and paste it here. It is stored encrypted and never shown again.",
  "submit": "Connect",
  "switcher": "Switch project",
  "status": {
    "active": "Connected",
    "failing": "Provider unreachable",
    "revoked": "Token rejected"
  },
  "permission": {
    "read": "Read only",
    "read_write": "Read & write"
  },
  "token_hint": "Token …{{hint}}",
  "synced": "Catalogue updated {{date}}",
  "neverSynced": "Catalogue not loaded yet",
  "refresh": "Refresh catalogue",
  "replaceToken": "Replace token",
  "forget": "Remove from CloudServer",
  "intro": "Each project here is one Hetzner Cloud project, connected with its own API token. Open a project to see and manage what runs in it.",
  "all": "All projects",
  "addLead": "Paste the API token of a Hetzner Cloud project. CloudServer checks it before saving.",
  "nameHint": "How the project is called in CloudServer; it does not have to match Hetzner.",
  "tokenWhy": "Hetzner tokens belong to one project, so every project is connected with its own token.",
  "connected": "Project “{{name}}” connected",
  "state": "Connection",
  "catalogue": "Catalogue",
  "open": "Open",
  "refreshed": "Catalogue of “{{name}}” updated",
  "forgetTitle": "Remove “{{name}}” from CloudServer?",
  "forgetToken": "CloudServer forgets the API token and everything it stored about this project.",
  "forgetKeep": "Nothing is deleted at Hetzner: servers, IPs and data keep running there.",
  "forgetBilling": "Hetzner keeps billing those resources; delete them first if you no longer need them.",
  "forgotten": "Project “{{name}}” removed from CloudServer",
  "emptyMember": "No projects for you yet",
  "emptyMemberLead": "An administrator gives you access to projects. Ask them, and the projects appear here."
}
